import { render, staticRenderFns } from "./FriendsView.vue?vue&type=template&id=3927a5a2&"
import script from "./FriendsView.vue?vue&type=script&lang=js&"
export * from "./FriendsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/common/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fviews%2FFriendsView.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports